import { render } from "./MapperView.vue?vue&type=template&id=70d74701&scoped=true&ts=true"
import script from "./MapperView.vue?vue&type=script&lang=ts"
export * from "./MapperView.vue?vue&type=script&lang=ts"

import "./MapperView.vue?vue&type=style&index=0&id=70d74701&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d74701"]])

export default __exports__